import { Box, Text } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Heading, Modal } from 'uikit'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  HeadingContainer,
} from 'uikit/layout'
import { useHistory, useParams } from 'react-router-dom'
import { faqTextOptions } from '../Faq.constants'
import { ItemForm } from './ItemForm'
import { useFaqCreate } from './services/useFaqCreate'
import { useFaqRemove } from './services/useFaqRemove'
import { useFaqUpdate } from './services/useFaqUpdate'
import { useFetchItem } from './services/useFetchItem'

export const Item = () => {
  const history = useHistory()
  const { id } = useParams()
  const [removeIsOpen, setOpenRemove] = useBoolean(false)
  const isNew = !id

  const handleBack = () => {
    history.goBack()
  }

  const { data, isLoading: itemIsLoading } = useFetchItem(id)

  const { mutate: updateItem, isLoading: isUpdating } = useFaqUpdate(id)
  const { mutate: createItem, isLoading: isCreating } = useFaqCreate()
  const { mutate: removeItem, isLoading: isRemoving } = useFaqRemove()

  const submitHandle = (values) => {
    const payload = {
      question: faqTextOptions.map((option, index) => ({
        language: option.value,
        text: values.list[index]?.question || '',
      })),
      answer: faqTextOptions.map((option, index) => ({
        language: option.value,
        text: values.list[index]?.answer || '',
      })),
      order: values.order,
      category: values.category,
    }

    if (isNew) {
      createItem(payload, {
        onSuccess: () => {
          handleBack()
        },
      })
    } else {
      updateItem(payload)
    }
  }

  const removeHandle = () => {
    removeItem(id, {
      onSuccess: () => {
        handleBack()
      },
    })
  }

  const list = data
    ? faqTextOptions.map((option) => {
        return {
          question: data.question.find((item) => item.language === option.value)?.text,
          answer: data.answer.find((item) => item.language === option.value)?.text,
        }
      })
    : []

  return (
    <Container>
      <CardContainer onBack={handleBack} indentTop={120}>
        <ContentContainer>
          <ContentContainerColumn>
            <HeadingContainer>
              <Heading>{isNew ? 'Добавить' : 'Обновить'}</Heading>
            </HeadingContainer>
            <ItemForm
              initialValues={
                !isNew ? { list, order: data?.order, category: data?.category } : undefined
              }
              onSubmit={submitHandle}
              onRemove={() => setOpenRemove(true)}
              isLoading={itemIsLoading || isUpdating || isCreating}
            />
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>

      <Modal isOpen={removeIsOpen} onClose={() => setOpenRemove(false)} title="Удалить элемент">
        <Text fontSize="20px" color="red.500">
          Внимание!
        </Text>
        <Text>Данное действие нельзя будет отменить.</Text>
        <Box pt="30px">
          <Button w="full" colorPalette="red" isLoading={isRemoving} onClick={removeHandle}>
            Продолжить
          </Button>
        </Box>
      </Modal>
    </Container>
  )
}
